<template>
  <div class="section-orders">
    <div class="d-flex gird-orders">
      <div class="panel-customer">
        <custom-input :label="$gettext('No')" :field="'number'"/>
        <custom-input :label="$gettext('Table')" v-if="bill.table" :field="'table'"/>
        <custom-input :label="$gettext('Room')" v-if="bill.room" :field="'room'"/>
        <custom-input :label="$gettext('Cover')" :field="'cover'"/>
        <custom-input
          :label="$gettext('Cst')"
          :field="'customer'"
          :model="bill.customer ? printName(bill.customer, 'customers') : null"
        />
        <custom-input :label="$gettext('Staff')" :field="'staff'"/>
        <custom-input :label="$gettext('Status')" :field="'status'" :model="status[bill.status] ? status[bill.status] : ''"/>
        <div class="panel-customer-footer">
          <div class="logo-left">
            <icon name="logo-icon"/>
            <img class="logo-pos" src="/assets/img/logo-text-in-white.png">
          </div>
        </div>
      </div>
      <!-- panel-customer -->
      <mq-layout :mq="['sm', 'md']">
        <p class="info-pos" v-if="shift">
          <span>{{ station ? station.name : '' }}</span>/<span>{{ location ? location.name : '' }}</span>,
          <span v-translate>Shift: </span>{{ shift.name }} - {{ printDate(shift.startTime, 'DD/MM/YYYY, HH:mm:ss') }}
        </p>
        <order-list/>
      </mq-layout>
      <div class="panel-display-order">
        <mq-layout mq="lg+">
          <p class="info-pos" v-if="shift">
            <span>{{ station ? station.name : '' }}</span>/<span>{{ location ? location.name : '' }}</span>,
            <span v-translate>Shift: </span>{{ shift.name }} - {{ printDate(shift.startTime, 'DD/MM/YYYY, HH:mm:ss') }}
          </p>
          <order-list/>
        </mq-layout>
        <div class="row order-footer">
          <div class="col-md-8 order-footer-btns">
            <div class="row-flex-wrap">
              <button
                id="toggleMixerModalTrigger"
                class="btn btn-default"
                @click="toggleMixerModal()"
                :disabled="!getLastItemMixers"
                :class="{'btn--active': getLastItemMixers}"
                v-translate
              >Side orders mixers</button>
              <button
                class="btn btn-default"
                @click="toggleCreditBackButton"
                :class="{'btn--active': isCreditBackButtonActive}"
                v-translate
              >Credit back</button>
              <button
                class="btn btn-default"
                @click="setStaffStation(true)"
                v-translate>
                Sign in
              </button>
              <toggle-router-link
                :class="{
                    'btn--active': isLastNormalItemNotCreditBack
                                    && getArticleCommission(getLastNormalItem.product)
                  }"
                :toRouteName="'set-commission'"
                :routeParams="{ product: getLastNormalItem ? getLastNormalItem.product : null }"
                :redirectCondition="[
                  bill.staff,
                  getLastNormalItem,
                  getLastNormalItem
                    && getArticleCommission(getLastNormalItem.product)
                ]"
                :errorMessage="[
                  $gettext('Please create new order or get bill'),
                  $gettext('Bill have no item'),
                  $gettext('Product have no commission')
                ]"
                v-translate
              >Commission</toggle-router-link>
              <toggle-router-link
                :toRouteName="'choose-cust'"
                :redirectCondition="[isBill('open'), !getLastNormalItem]"
                :errorMessage="[$gettext('Please get an open bill'), $gettext('Please print bill first')]"
                v-translate
              >Choose customer</toggle-router-link>
            </div>
            <div class="row-flex-wrap">
              <toggle-router-link
                :toRouteName="'order-level'"
                :disabled="!hasSelectedItem"
                :class="{'btn--active': hasSelectedItem}"
                v-translate
              >Order level</toggle-router-link>
              <button class="btn btn-default" @click="$store.getters.removeLastLine()" v-translate>Remove last line</button>
              <button
                class="btn btn-default"
                @click="setStaffStation(false)"
                v-translate
              >Sign out</button>
              <toggle-router-link
                :toRouteName="'add-note'"
                :redirectCondition="hasSelectedItem"
                :errorMessage="$gettext('Please select an item')"
                :class="{'btn--active': isAddNoteButtonActive}"
                v-translate
              >Add note cooking</toggle-router-link>
              <toggle-router-link
                :toRouteName="'add-customer'"
                :redirectCondition="[can('addCustomer')]"
                :errorMessage="[$gettext('Permission denied')]"
                v-translate
              >Add customer</toggle-router-link>
            </div>
          </div>
          <div class="col-md-4 order-footer-total">
            <div class="split-merge">
              <toggle-router-link
                :toRouteName="'split-bill'"
                :routeParams="{ bill: bill }"
                :redirectCondition="[can('closeBill'), isBill('open')]"
                :errorMessage="[
                  $gettext('Permission denied'),
                  $gettext('Please get an open bill')
                ]"
                v-translate
              >Split</toggle-router-link>
              <toggle-router-link
                :toRouteName="'merge-bill'"
                :routeParams="{ bill: bill }"
                :redirectCondition="[can('closeBill'), isBill('open')]"
                :errorMessage="[
                  $gettext('Permission denied'),
                  $gettext('Please get an open bill')
                ]"
                v-translate
              >Merge</toggle-router-link>
            </div>
            <div class="btn btn-plain ml-auto total">
              <span v-translate>total amount</span>
              <big>{{ totalAmount | currency }}</big>
            </div>
            <div class="pay-paycash">
              <toggle-router-link
                :toRouteName="'pay'"
                :redirectCondition="[can('closeBill'), isBill('open'), !getLastNormalItem]"
                :errorMessage="[
                  $gettext('Permission denied'),
                  $gettext('Please get an open bill'),
                  $gettext('Please print bill first')
                ]"
                v-translate
              >PAY</toggle-router-link>
              <div class="wp-paycash" v-if="can('closeBill')">
                <toggle-router-link
                  :toRouteName="'pay-cash'"
                  :class="'btn-paycash'"
                  :redirectCondition="[isBill('open'), !getLastNormalItem]"
                  :errorMessage="[$gettext('Please get an open bill'), $gettext('Please print bill first')]"
                  v-translate
                >Pay cash</toggle-router-link>
                <input-pad
                  :item="$store.state.bill"
                  :property="'payCash'"
                  :maxLength="10"
                  :attributes="{'placeholder': $gettext('Enter total amount')}" 
                  :usingDecimal="usingDecimal"
                />
              </div>
              <div class="wp-paycash" v-else>
                <toggle-router-link
                  class="btn-paycash dummy"
                  v-translate
                >Pay cash</toggle-router-link>
                <input-pad
                  :item="$store.state.bill"
                  class="dummy"
                  :property="'payCash'"
                  :maxLength="10"
                  :attributes="{'placeholder': $gettext('Enter total amount')}" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- panel-display-order -->
      <div class="panel-invoice-right">
        <div class="calculator-area">
          <div class="box-header">
            <toggle-router-link
              :toRouteName="'new-order'"
              :className="'btn btn-light'"
              :redirectCondition="shift != null && shift != false"
              :errorMessage="$gettext('Please start shift')"
              v-translate
            >New</toggle-router-link>
            <button class="btn btn-light" @click="changePad">
              <translate v-show="isNumPad">Alphabet</translate>
              <translate v-show="!isNumPad">Numpad</translate>
            </button>
            <mq-layout :mq="['sm', 'md']" :class="'box-header-fields-mobile'">
              <input-pad
                :ref="'billId'"
                :item="getAction"
                :property="'billId'"
                :attributes="{
                  'class': 'form-control form-control-lg',
                  'placeholder': $gettext('Enter Bill ID')
                }"/>
              <input-pad
                :ref="'staffRef'"
                :item="getAction"
                :property="'staffRef'"
                :alphabetable="true"
                :attributes="{
                  'class': 'form-control form-control-lg',
                  'placeholder': $gettext('Enter Staff ID')
                }"/>
              <toggle-router-link :toRouteName="'bills-open'" v-translate>Open bills</toggle-router-link>
            </mq-layout>
          </div>
          <div class="calculator-keys" v-if="isNumPad">
            <button
              v-for="(key, i) in calculatorKeys"
              :key="i"
              class="btn btn-light calculator-key"
              @click="inputKeyPad(key)"
            >{{ key }}</button>
          </div>
          <div class="calculator-keys alphabet" v-else>
            <button
              v-for="(key, i) in alphabetKeys"
              :key="i"
              class="btn btn-light calculator-key"
              @click="inputKeyPad(key)"
            >{{ key }}</button>
          </div>
          <toggle-router-link
            :toRouteName="'bills-open'"
            :className="'btn btn-light btn-block d-none d-md-block mb-md-2'"
            v-translate
          >Open bills</toggle-router-link>
          <button
            class="btn btn-light btn-block d-none d-md-block mb-md-2"
            @click="pusleDrawer"
            v-translate
          >Open Drawer</button>
          <button
            class="btn btn btn-default btn-toggle-menu"
            @click="toggleMenuSide()"
            :class=" isMenuSideVisible ? 'isOpen' : 'isClose' "
          ></button>
          <button
            class="btn btn btn-default btn-toggle-menu isOpen"
            @click="$router.push('order')"
            v-if="$route.meta.fullPage"
            v-translate
          ></button>
        </div>
        <div class="action-area">
          <button class="btn btn-default" @click="postBill" v-translate>Print</button>
          <toggle-router-link
            :toRouteName="'change-order'"
            :redirectCondition="bill.staff !== ''"
            v-translate
          >Change Table/Room/Cover</toggle-router-link>
          <button class="btn btn-default" @click="onVoid" v-translate>Void</button>
          <button class="btn btn-default" @click="doAction" v-translate>Ok</button>
          <button class="btn btn-default" @click="$store.dispatch('clearOrder')" v-translate>Clear</button>
          <mq-layout mq="lg+" :class="'d-flex flex-column mt-auto'">
            <input-pad
              :ref="'billId'"
              :item="getAction"
              :property="'billId'"
              :attributes="{
                'class': 'form-control form-control-lg',
                'placeholder': $gettext('Enter Bill ID')
              }"/>
            <input-pad
              :ref="'staffRef'"
              :item="getAction"
              :property="'staffRef'"
              :alphabetable="true"
              :attributes="{
                'class': 'form-control form-control-lg',
                'placeholder': $gettext('Enter Staff ID')
              }"/>
          </mq-layout>
        </div>
      </div>
      <!-- panel-invoice-right -->
    </div>
    <!-- d-flex -->
    <bill-modal v-if="isBillModalVisible"/>
    <menu-side v-if="isMenuSideVisible"/>
  </div>
  <!-- section-orders -->
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import BillModal from '@/components/BillModal.vue';
import CustomInput from '@/components/CustomInput.vue';
import OrderList from '@/components/OrderList.vue';
import MenuSide from '@/components/MenuSide.vue';
import ToggleRouterLink from '@/components/ToggleRouterLink.vue';
import StaffService from '@/services/StaffService';
import AuthService from '@/services/AuthService';
import ShiftService from '@/services/ShiftService';

import {
  SET_CONFIRM_MODAL,
  SET_MESSAGE_MODAL,
  TOGGLE_PAY_BILL_MODAL_VISIBLE,
  TOGGLE_BILL_MODAL_VISIBLE,
  TOGGLE_CREDIT_BACK_BUTTON,
  TOGGLE_MIXER_MODAL,
  TOGGLE_MENU_SIDE,
} from '@/store/mutation-types';
import { ON_INPUT_PAD, SET_STAFF_STATION } from '@/store/action-types';

export default {
  name: 'OrderDetail',
  components: {
    BillModal,
    CustomInput,
    OrderList,
    MenuSide,
    ToggleRouterLink,
  },
  data() {
    return {
      calculatorKeys: [
        '7', '8', '9',
        '4', '5', '6',
        '1', '2', '3',
        '0', '.', '<',
      ],
      alphabetKeys: [
        'A', 'B', 'C', 'D', 'E', 'F', 'G',
        'H', 'I', 'J', 'K', 'L', 'M', 'N',
        'O', 'P', 'Q', 'R', 'S', 'T', 'U',
        'V', 'W', 'X', 'Y', 'Z', '<'
      ],
      getAction: {
        staffRef: '',
        billId: '',
      },
      status: {
        0: 'Open',
        1: 'Closed',
        2: 'Voided'
      }
    };
  },
  computed: {
    isNumPad: {
      get() { return this.$store.state.toggle.isNumPad },
      set(value) { this.$store.state.toggle.isNumPad = value; }
    },
    billIsValid() {
      // This condition will be modified later.
      return this.bill.billItems.length > 0 && this.bill.staff;
    },
    isMenuSideVisible() {
      if (this.$route.meta.fullPage) {
        return true;
      }
      return this.isMenuSideVisibleState;
    },
    hasSelectedItem() {
      const selectedItem = this.$store.state.bill.selectedItem;
      if (!selectedItem || selectedItem.empty || selectedItem.qty < 0) return false;
      return true;
    },
    isAddNoteButtonActive() {
      return this.hasSelectedItem && this.getSelectedItemCookingOptions;
    },
    isLastNormalItemNotCreditBack() {
      return this.getLastNormalItem && this.getLastNormalItem.qty > 0;
    },
    ...mapState({
      bill: state => state.bill.bill,
      firstBill: state => state.bill.firstBill,
      secondBill: state => state.bill.secondBill,
      isBillModalVisible: state => state.toggle.isBillModalVisible,
      isCreditBackButtonActive: state => state.toggle.isCreditBackButtonActive,
      isMenuSideVisibleState: state => state.toggle.isMenuSideVisible,
      shift: state => state.auth.user.shift,
      location: state => state.auth.user.location,
      station: state => state.auth.user.station,
      currentInputPad: state => state.inputPad.currentInputPad,
      lastPing: state => state.bill.lastPing,
      ajaxCounter: state => state.bill.ajaxCounter,
      nextPingIn: state => state.bill.nextPingIn,
      user: state => state.auth.user,
      currentInputPad: state => state.inputPad.currentInputPad,
    }),
    ...mapGetters([
      'totalAmount',
      'getLastItemMixers',
      'getLastNormalItem',
      'getArticleCommission',
      'isBill',
      'getSelectedItemCookingOptions',
      'checkStaffLocation',
    ]),
    usingDecimal() { return this.$store.state.auth.currency.decimalType }
  },
  methods: {
    async pusleDrawer() {
      const data = await ShiftService.pusleDrawer();
      if (data && !data.error) {
        await this.$store.dispatch('print', { billData: data, printProductTicket: false });
      } else {
        this.$store.commit(SET_MESSAGE_MODAL, data);
      }
    },

    inputKeyPad(key, user) {
      this.$store.dispatch(ON_INPUT_PAD, key);
    },
    async postBill() {
      if (this.$router.currentRoute.name !== 'order') {
        this.$router.push({ name: 'order' });
      }
      if (this.bill.billItems.length === 0) {
        if(this.bill && this.bill.id) {
          this.$store.commit(TOGGLE_BILL_MODAL_VISIBLE, true);
        }
      } else if (!this.shift) {
        this.$store.commit(
          SET_MESSAGE_MODAL,
          this.$gettext('Please start shift'),
        );
      } else if (!this.bill.staff) {
        this.$store.commit(
          SET_MESSAGE_MODAL,
          this.$gettext('Please choose staff'),
        );
      } else {
        this.$store.dispatch('postBill', this.bill);
        this.$store.state.bill.selectedItem = null;
      }
    },
    focusPreviousNo() {
      if (this.$router.currentRoute.name !== 'order') {
        this.$router.push({ name: 'order' });
      }
      this.$refs.billId.$refs.input.click();
    },
    changePad() {
      if(this.currentInputPad.element) {
        this.$store.dispatch(ON_INPUT_PAD, 'Windows');
      }
      this.isNumPad = !this.isNumPad;
    },
    toggleCreditBackButton() {
      /* Not allow to credit back when making order */
      const isInOrder = this.bill.billItems.find(({ qty }) => qty > 0) !== undefined;

      if (this.isBill('open') && !isInOrder) {
        this.$store.commit(TOGGLE_CREDIT_BACK_BUTTON);
      }
    },
    onVoid() {
      if (!this.isCashier) {
        this.$store.commit(SET_MESSAGE_MODAL, this.$gettext('Permission denied'));
        return;
      }
      if (this.isBill('open')) {
        this.$store.commit(SET_CONFIRM_MODAL, {
          action: this.$gettext('void bill'),
          context: this,
          func: () => {
            this.$router.push({ name: 'void-bill' })
            this.$store.commit(SET_CONFIRM_MODAL, null);
          },
        });
      } else {
        this.$store.commit(SET_MESSAGE_MODAL, this.$gettext('Please get an open bill'));
      }
    },
    async setStaffStation(status) {
      if (!this.isCashier) {
        this.$store.commit(SET_MESSAGE_MODAL, this.$gettext('Permission denied'));
        return;
      }
      const staff = this.getObject(this.getAction.staffRef, 'staffs', 'ref');
      const _this = this;
      if (!staff) {
        this.$store.commit(
          SET_MESSAGE_MODAL,
          this.$gettext('Staff not found'),
        );
        return;
      }
      const modalHeaderText = `${staff.station
        ? this.$gettext('sign out staff')
        : this.$gettext('sign in staff')
      } ${staff.firstName} ${staff.lastName}`;
      const data = {
        staffId: staff.id,
        setStationNull: !!(!this.checkStaffLocation(staff) && staff.station),
        station: this.checkStaffLocation(staff) && staff.station ? null : this.station.id,
      };

      await this.$store.commit(SET_CONFIRM_MODAL, {
        action: modalHeaderText,
        context: this,
        data,
        func: () => _this.$store.dispatch(SET_STAFF_STATION, data),
      });

      // if (this.checkStaffLocation(staff)) {
      //   this.$store.commit(
      //     SET_MESSAGE_MODAL,
      //     this.$gettext('Staff successfully signed in')
      //   );
      // } else {
      //   this.$store.commit(
      //     SET_MESSAGE_MODAL,
      //     this.$gettext('Staff successfully signed out')
      //   );
      // }
    },
    async doAction() {
      if (this.currentInputPad.property === 'billId') {
        const bill = this.getObject(this.getAction.billId, 'bills', 'number');
        if (bill) {
          if (!this.shift) {
            this.$store.commit(
              SET_MESSAGE_MODAL,
              this.$gettext('Please start shift'),
            );
          } else {
            await this.$store.dispatch('setBill', Object.assign({}, bill));
            this.$router.push({ name: 'order' });
            if (bill.status !== 0) {
              if(bill.status == 1) {
                this.$store.state.bill.billModal = 'reprint';
              } else if (bill.status == 2) {
                this.$store.state.bill.billModal = 'voided';
              }
              this.$store.commit(TOGGLE_BILL_MODAL_VISIBLE, true);
            }
          }
        } else {
          this.$store.commit(SET_MESSAGE_MODAL, this.$gettext('Bill not found'));
        }
      } else if (this.currentInputPad.property === 'staffRef') {
        const staff = this.getObject(this.getAction.staffRef, 'staffs', 'ref');
        if (staff) {
          const checkStaff = this.$store.getters.checkStaff(staff.id);
          if (checkStaff.valid) {
            this.bill.staff = staff.id;
            this.bill.billItems.forEach((item) => {
              if (item.type != this.COMMISSION_ITEM) {
                item.staff = this.bill.staff;
              }
            });
          } else {
            this.$store.commit(SET_MESSAGE_MODAL, checkStaff.data.message);
          }
        } else {
          this.$store.commit(SET_MESSAGE_MODAL, this.$gettext('Staff not found'));
        }
      }
    },
    ...mapMutations([
      TOGGLE_MIXER_MODAL,
      TOGGLE_MENU_SIDE,
    ]),
  },
  async created() {
    // autoload staffs for sign in / sign out
    const staffs = this.getArray('staffs');
    setInterval(async () => {
      if (this.ajaxCounter <= 0) {
        if (this.nextPingIn > 0) {
          this.$store.state.bill.nextPingIn--;
        } else {
          this.$store.state.bill.nextPingIn = 5;
          const response = await AuthService.ping(this.lastPing);
          if(!response) return;
          if(!localStorage.getItem('latestCommit')) {
            if(response && response.latestCommit) {
              localStorage.setItem('latestCommit', response.latestCommit);
            }
          } else {
            if(response 
                && response.latestCommit 
                && response.latestCommit != localStorage.getItem('latestCommit')
            ) {
              this.$store.commit(SET_CONFIRM_MODAL, {
                message: 'An update has been released, after OK has been clicked you will be logout. Login again to continue your work. Thank you!',
                context: this,
                func: () => {
                  localStorage.clear();
                  window.location.reload(true);
                },
              });
            }
          }
          if (
            ( response.station 
              && this.user 
              && this.user.station 
              && response.station.id != this.user.station.id
            ) 
            || !response.station
          ) {
            localStorage.clear();
            window.location.reload();
          }
          if (response.shift != this.user.shift) {
            this.$store.state.auth.user.shift = response.shift;
            localStorage.setItem('pos_user', JSON.stringify(this.user));
          }
          if (response.workDay != this.user.workDay) {
            this.$store.state.auth.user.workDay = response.workDay;
            localStorage.setItem('pos_user', JSON.stringify(this.user));
          }
          if ((response.bills || []).length > 0) {
            response.bills.forEach((bill) => {
              // only update not current bill, it might be showing on modal
              if (
                  ( bill.id != this.bill.id
                    || !this.isBillModalVisible)
                  && (!this.secondBill.id
                      || !this.firstBill.id)
              ) {
                this.$set(this.$store.state.bill.bills, bill.id, bill);
                if(bill.id == this.bill.id) {
                  this.$store.dispatch('setBill', Object.assign({}, bill));
                }
              }
            });
          }
          if (response.staffs && response.staffs.length > 0) {
            response.staffs.forEach((staff) => {
              this.$set(this.$store.state.staff.staffs, staff.id, staff);
            });
          }
          if (response.customers && response.customers.length > 0) {
            response.customers.forEach((customer) => {
              this.$set(this.$store.state.customer.customers, customer.id, customer);
            });
          }
          if (response.location && response.location.id) {
            this.$store.commit('setLocation', response.location);
          }
        }
      }
    }, 1000);
  },
};
</script>

<style lang="scss" scoped>
.logo-left {
  svg {
    width: 52px;
    height: 45px;
  }
}
.logo-right {
  display: none;
  @media (min-height: 600px) and (orientation: landscape) and (min-width: 768px) {
    display: block;
    position: absolute;
    bottom: 0;
    right: 0;
    width: calc(100% - 15px);
    text-align: center;
    z-index: 0;
    img {
      max-width: 100%;
    }
  }
}
</style>
